import { createContext, useState } from "react";

const TabPanelContext = createContext();

const TabPanelContextProvider = ({ children }) => {
  const [tabFormHandler, setTabFormHandler] = useState({ handler: {}, data: {}, tabIndex: "0", prevData: {}, isDirty: false, isValid: true });

  const setTabFormContext = (formhandler) => {
    let _formData = {
      currentData: null,
      prevData: null,
    };
    if (formhandler.data) {
      _formData.currentData = formhandler.data;
      delete formhandler.data;
    }

    if (formhandler.prevData) {
      _formData.prevData = formhandler.prevData;
      delete formhandler.prevData;
    }
    setTabFormHandler((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        ..._formData?.currentData,
      },
      prevData: {
        ...prev.prevData,
        ..._formData?.prevData,
      },
      ...formhandler,
    }));
  };
  const getTabFormContext = () => {
    return tabFormHandler;
  };

  return <TabPanelContext.Provider value={{ getTabFormContext, setTabFormContext }}>{children}</TabPanelContext.Provider>;
};

export { TabPanelContext, TabPanelContextProvider };
